import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterByName',
    pure: false
})
export class FilterByNamePipe implements PipeTransform {
    transform(items: any[], conditions: any): any {
        return conditions ? items.filter(item =>
            item.ProfileName?.toLowerCase().indexOf(conditions?.name.toLowerCase()) > -1) : items;
    }
}
